import { render, staticRenderFns } from "./SendOrderFlb.vue?vue&type=template&id=22260170&scoped=true"
import script from "./SendOrderFlb.vue?vue&type=script&lang=js"
export * from "./SendOrderFlb.vue?vue&type=script&lang=js"
import style0 from "./SendOrderFlb.vue?vue&type=style&index=0&id=22260170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22260170",
  null
  
)

export default component.exports